import { useState, useContext } from 'react';
import Modal from './index';
import { ModalContext } from '../ModalContext';
import { useForm, } from "react-hook-form"
import { AdminAddOrderToProjectFunction, AdminReloadFunction, } from '../interfaces';
import { AdminPersonsResponse, } from '../../../backend/src/api/dto';

type FormValues = {
    name: string
    description: string
    withActivities: boolean
    visible: boolean
}

function AdminAddOrderToProject({ item, reload, addFunction }: {
    item: any,
    reload: AdminReloadFunction,
    addFunction: AdminAddOrderToProjectFunction,

}) {


    const [showModal, closeModal] = useContext(ModalContext);
    const { register, control, handleSubmit, getValues, } = useForm<FormValues>({
        defaultValues: {
            name: '',
            description: '',
            withActivities: false,
            visible: true
        }
    })

    const [loading, setLoading] = useState(true);
    const [sending, setSending] = useState(false);
    const [data, setData] = useState<AdminPersonsResponse>();
    const [apiResult, setApiResult] = useState<null | { status: boolean }>(null)


    const modalButtons = [
        {
            text: 'Confirm',
            icon: 'check',
            onClick: () => onSubmit(),

            style: 'primary'
        }, {
            text: 'Cancel',
            icon: 'xmark',
            onClick: 'closeModal',
            style: 'secondary'
        }
    ];


    const onSubmit = () => {
        //const form = getValues();
        setSending(true);
        return new Promise((resolve, reject) => {
            handleSubmit((data) => {
                setLoading(false);
                setApiResult({
                    status: true,
                })
                addFunction(data.name, data.description, data.withActivities, data.visible).then(() => {
                    if (reload) {
                        console.log('in reload')
                        reload().then(() => {
                            closeModal(null);
                            resolve(1)
                        })
                    } else {
                        closeModal(null);
                        resolve(1)
                    }
                }).catch((e: any) => {
                    setLoading(false);
                    setApiResult(e)
                    resolve(1)
                })
                setSending(false)
            })()
        })
    }

    return (
        <Modal
            buttons={modalButtons}
            title={'Pridať komponent k projektu'}
            errorObject={apiResult}
            disableAllButtons={sending}
        >
            <form style={{ minHeight: '300px' }}>
                <div className="row">
                    <div className="col-3 mt-1 text-end">
                        <label className="form-label">Názov</label>
                    </div>
                    <div className="col-9">
                        <input type="text" {...register("name")} className="form-control form-control-sm" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-3 mt-1 text-end">
                        <label className="form-label">Popis</label>
                    </div>
                    <div className="col-9">
                        <textarea rows={6} {...register("description")} className="form-control form-control-sm" />
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="offset-3 col-9">
                        <div className="form-check">
                            <input className="form-check-input" {...register("withActivities")} type="checkbox" />
                            <label className="form-check-label">
                                s Aktivitami
                            </label>
                        </div>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="offset-3 col-9">
                        <div className="form-check">
                            <input className="form-check-input" {...register("visible")} type="checkbox" />
                            <label className="form-check-label">
                                Viditeľné
                            </label>
                        </div>
                    </div>
                </div>
            </form>
        </Modal>
    )

}

export default AdminAddOrderToProject
